import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = ["data-invalid"]
const _hoisted_2 = ["for"]
const _hoisted_3 = {
  key: 0,
  class: "main-alert"
}
const _hoisted_4 = { class: "w-full form-field__field" }
const _hoisted_5 = {
  key: 0,
  class: "main-alert font-size-14 form-field__error"
}

type EsFieldProps = {
    fieldId: string;
    label: string;
    isMandatory?: boolean;
    error?: string;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'esFormField',
  props: {
    fieldId: {},
    label: {},
    isMandatory: { type: Boolean },
    error: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "w-full form-field",
    "data-invalid": Boolean(props.error)
  }, [
    _createElementVNode("label", {
      for: props.fieldId,
      class: "form-field__label col-0-8 main-m font-m align-r"
    }, [
      _createTextVNode(_toDisplayString(props.label), 1),
      (props.isMandatory)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, "*"))
        : _createCommentVNode("", true)
    ], 8, _hoisted_2),
    _createElementVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    (Boolean(props.error))
      ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.error), 1))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}
}

})